Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Atlas", {
    enumerable: true,
    get: function() {
        return Atlas;
    }
});
const _currency = require("./currency.cjs");
const _country = require("./country.cjs");
const _market = require("./market.cjs");
const _brand = require("./brand.cjs");
const _site = require("./site.cjs");
const _builder = require("./builder.cjs");
const _translation = require("./translation.cjs");
const _isrtl = require("./is-rtl.cjs");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Atlas {
    static builder(env) {
        return new _builder.AtlasBuilder(env);
    }
    static isRTL(languageOrLocale) {
        return (0, _isrtl.isRTL)(languageOrLocale);
    }
    async performRefresh() {
        const nextDef = await this.fetcher?.refresh();
        if (nextDef) {
            this.updateDef(nextDef);
        }
    }
    // eslint-disable-next-line max-statements
    updateDef(atlasDef) {
        if (!atlasDef || typeof atlasDef !== 'object' || !atlasDef.version) {
            throw new Error('Invalid AtlasDef provided to updateDef');
        }
        if (this.version === atlasDef.version) return;
        this.version = atlasDef.version;
        this.allCurrencies = atlasDef.currencyDefs.map((currencyDef)=>new _currency.Currency(currencyDef));
        this.allCountries = atlasDef.countryDefs.map((countryDef)=>new _country.Country(countryDef, this.allCurrencies));
        this.allMarkets = atlasDef.marketDefs.map((marketDef)=>new _market.Market(marketDef, this.allCountries));
        this.allSites = atlasDef.siteDefs.map((siteDef)=>new _site.Site(siteDef, this.env, this.allMarkets));
        this.allBrands = atlasDef.brandDefs.map((brandDef)=>_brand.Brand.fromDef(brandDef, this.env, this.allMarkets, this.allSites));
        this.allTranslations = atlasDef.translationDefs.map((translationDef)=>new _translation.Translation(translationDef));
        this.brandUidLookups.clear();
        this.brandPlidLookups.clear();
        this.allBrands.forEach((brand)=>{
            if (!this.brandUidLookups.has(brand.uid.toLowerCase())) {
                this.brandUidLookups.set(brand.uid.toLowerCase(), brand);
            }
            if (!this.brandPlidLookups.has(brand.plid)) {
                this.brandPlidLookups.set(brand.plid, brand);
            }
        });
        this.currencyLookups.clear();
        this.allCurrencies.forEach((currency)=>{
            if (!this.currencyLookups.has(currency.code.toLowerCase())) {
                this.currencyLookups.set(currency.code.toLowerCase(), currency);
            }
        });
        this.translationLocaleLookups.clear();
        this.allTranslations.forEach((translation)=>{
            this.translationLocaleLookups.set(translation.locale.toLowerCase(), translation);
        });
        this.baseGenericBrand = this.allBrands.find((brand)=>brand.plid === -1);
    }
    createGenericBrand(plid) {
        return _brand.Brand.fromBrand(this.baseGenericBrand, plid);
    }
    findBrandByDomain(domain) {
        void this.performRefresh();
        return this.allBrands.find((brand)=>domain.toLowerCase().includes(brand.domain.toLowerCase()));
    }
    findBrandByPlid(plid) {
        void this.performRefresh();
        return this.brandPlidLookups.get(plid);
    }
    resolveBrandByPlid(plid) {
        void this.performRefresh();
        const brand = this.brandPlidLookups.get(plid);
        if (brand) {
            return brand;
        }
        return this.createGenericBrand(plid);
    }
    findBrandByUid(uid) {
        void this.performRefresh();
        return this.brandUidLookups.get(uid.toLowerCase());
    }
    findCurrencyByCode(code) {
        void this.performRefresh();
        return this.currencyLookups.get(code.toLowerCase());
    }
    findTranslationByLocale(locale) {
        void this.performRefresh();
        return this.translationLocaleLookups.get(locale.toLowerCase());
    }
    constructor(env, atlasDef, fetcher){
        _define_property(this, "env", void 0);
        _define_property(this, "version", '');
        _define_property(this, "allBrands", []);
        _define_property(this, "allCurrencies", []);
        _define_property(this, "allCountries", []);
        _define_property(this, "allMarkets", []);
        _define_property(this, "allSites", []);
        _define_property(this, "allTranslations", []);
        _define_property(this, "brandUidLookups", new Map());
        _define_property(this, "brandPlidLookups", new Map());
        _define_property(this, "currencyLookups", new Map());
        _define_property(this, "translationLocaleLookups", new Map());
        _define_property(this, "baseGenericBrand", void 0);
        _define_property(this, "fetcher", void 0);
        if (!atlasDef || typeof atlasDef !== 'object' || !atlasDef.version) {
            throw new Error('Invalid AtlasDef provided to Atlas constructor');
        }
        this.env = env;
        if (fetcher?.enabled) {
            this.fetcher = fetcher;
        }
        this.updateDef(atlasDef);
    }
}
